import { Component, output, input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { NavigationItem } from '../header.model';

import '@asn/icon';

@Component({
    selector: 'ap-search-icon',
    templateUrl: './search-icon.component.html',
    styleUrls: ['./search-icon.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ApSearchIconComponent {
    /**
     * Required - The search navigation item
     */
    public readonly searchNavigationItem = input.required<NavigationItem>();

    /**
     * emits if the search button is clicked
     */
    public readonly searchClicked = output<NavigationItem>();
}
